<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
             <div>
              <span id="client-locations-filter-nombre-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.name')}}</span>
              <el-form-item prop="Nombre">
                <el-input
                  class="w-full"
                  v-model="form.Nombre.value"
                  maxlength="250"
                  aria-labelledby="client-locations-filter-nombre-label"
                >
                  <template v-if="form.Nombre.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de nombre"
                      @clear="form.Nombre.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <span id="client-locations-filter-codigo-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.code')}}</span>
              <el-form-item prop="Codigo">
                <el-input
                  class="w-full"
                  v-model="form.Codigo.value"
                  maxlength="30"
                  aria-labelledby="client-locations-filter-codigo-label"
                >
                  <template v-if="form.Codigo.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de código"
                      @clear="form.Codigo.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <span id="client-locations-filter-url-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.url')}}</span>
              <el-form-item prop="URL">
                <el-input
                  class="w-full"
                  v-model="form.URL.value"
                  maxlength="100"
                  aria-labelledby="client-locations-filter-url-label"
                >
                  <template v-if="form.URL.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de URL"
                      @clear="form.URL.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>

          <div>
            <AccessibleElSelect
              v-model="form.nombreAgrupacion.value"
              prop="nombreAgrupacion"
              :options="listGroupingForAccessibleSelect"
              :withFormItem="true"
              id-prefix="clientlocationsfilter"
            >
              <template slot="label">{{$t('app.single_grouping')}}</template>
            </AccessibleElSelect>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
// import moment from 'moment'
import { i18n } from '@/i18n'

// import { i18n } from '@/i18n'
import { getAgrupacionesNombreLocations } from '@/services/configurations/grouping/getAgrupacionesNombreLocations'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    listGroupingForAccessibleSelect: function () {
      return this.listGrouping.map(item => ({
        id: item,
        name: item
      }))
    }
  },
  data: function () {
    return {
      vuexnamespace: 'clientlocations',
      isOpen: this.panelOpen,
      form: {
        Codigo: { label: i18n.t('configurations.code'), value: '' },
        Nombre: { label: i18n.t('configurations.name'), value: '' },
        URL: { label: i18n.t('app.url'), value: '' },
        nombreAgrupacion: { label: i18n.t('app.single_grouping'), value: '' },
      },
      listGrouping: [],
    }
  },
  mounted: async function () {
    const dataAgrupaciones = await getAgrupacionesNombreLocations()
    if (dataAgrupaciones.blnError === true) {
      this.doFeedback(dataAgrupaciones.msgError + ' [Código de error: ' + dataAgrupaciones.codError + ']')
    }
    this.listGrouping = dataAgrupaciones.Respuesta
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.Nombre.value = _temp.Nombre !== undefined && _temp.Nombre ? _temp.Nombre.value : ''
        this.form.Codigo.value = _temp.Codigo !== undefined && _temp.Codigo ? _temp.Codigo.value : ''
        this.form.URL.value = _temp.URL !== undefined && _temp.URL.value !== '' ? _temp.URL.value : ''
        this.form.nombreAgrupacion.value = _temp.nombreAgrupacion !== undefined && _temp.nombreAgrupacion.value !== '' ? _temp.nombreAgrupacion.value : ''
      }
      // console.log('_temp =>', _temp)
      // console.log('form =>', this.form)
    },
    watchFormHandler: function ({ certificate }) {
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        Codigo: { label: i18n.t('configurations.code'), value: '' },
        Nombre: { label: i18n.t('configurations.name'), value: '' },
        URL: { label: i18n.t('app.url'), value: '' },
        nombreAgrupacion: { label: i18n.t('app.single_grouping'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
